






















































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import SeoForm from "@/components/forms/SeoForm.vue";
import SeoEntity from "@/entity/SeoEntity";

@Component({
    components: {
        SeoForm,
        DeleteButton,EForm,Number,TextField,Id
    }
})
export default class SeoSettings extends  Vue{
    items : SeoEntity[] = [];
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = "seo";
    action:string = this.baseAction;
    data : SeoEntity = new SeoEntity();
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "seo_id"
        },
        {text: "Kod", value: "code"},
        {text: "Başlık", value: "title"},
        {text: "Keywords", value: "meta_keywords"},
        {text: "Açıklama", value: "meta_description"},
        {text: "İşlemler", value: "actions"}
    ];
    edit(item:SeoEntity){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.seo_id;
        this.dialog = true;
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new SeoEntity();
        this.dialog = true;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    created(){
        this.get();
    }
};
